import './styles.css';
import { mountBgRemoveTab } from './ui/bgRemoveTab.js';
import { mountDpiTab } from './ui/dpiTab.js';

function setupTabs(): void {
  const tabBg = document.getElementById('tab-bgremove') as HTMLButtonElement;
  const tabDpi = document.getElementById('tab-dpi') as HTMLButtonElement;
  const panelBg = document.getElementById('panel-bgremove') as HTMLElement;
  const panelDpi = document.getElementById('panel-dpi') as HTMLElement;

  let bgMounted = false;
  let dpiMounted = false;

  function activate(tab: 'bg' | 'dpi'): void {
    const showBg = tab === 'bg';
    tabBg.setAttribute('aria-selected', String(showBg));
    tabDpi.setAttribute('aria-selected', String(!showBg));
    tabBg.tabIndex = showBg ? 0 : -1;
    tabDpi.tabIndex = showBg ? -1 : 0;
    panelBg.hidden = !showBg;
    panelDpi.hidden = showBg;

    if (showBg && !bgMounted) {
      mountBgRemoveTab(panelBg);
      bgMounted = true;
    }
    if (!showBg && !dpiMounted) {
      mountDpiTab(panelDpi);
      dpiMounted = true;
    }
  }

  tabBg.addEventListener('click', () => activate('bg'));
  tabDpi.addEventListener('click', () => activate('dpi'));

  for (const [btn, other] of [
    [tabBg, tabDpi],
    [tabDpi, tabBg],
  ] as const) {
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        other.focus();
        other.click();
      }
    });
  }

  activate('bg');
}

function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('sw.js').catch(() => {
      // Offline-first app still works without the SW (just without the install/offline-cache benefits);
      // fails silently here since this is non-critical and shouldn't interrupt first use.
    });
  });
}

// Chrome on Android (and desktop Chrome/Edge) offer to install the PWA: keep the prompt and show an
// Install App button in the header. Safari never fires this, so iPhone keeps Share › Add to Home Screen.
function setupInstallButton(): void {
  const btn = document.getElementById('install-app') as HTMLButtonElement | null;
  if (!btn) return;
  const standalone = matchMedia('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;
  let deferred: (Event & { prompt(): Promise<void>; userChoice: Promise<unknown> }) | null = null;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    if (standalone) return;
    deferred = e as typeof deferred;
    btn.hidden = false;
  });
  window.addEventListener('appinstalled', () => { deferred = null; btn.hidden = true; });
  btn.addEventListener('click', async () => {
    if (!deferred) return;
    const p = deferred;
    deferred = null;
    btn.hidden = true;
    await p.prompt();
    await p.userChoice;
  });
}

setupTabs();
setupInstallButton();
registerServiceWorker();
